<template>
  <v-dialog
    v-model="openPdfDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    content-class="pdf-dialog-container"
    @keydown.esc="closeDialog"
  >
    <div>
      <v-toolbar dark color="secondary" class="pdf-toolbar">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <div class="pdf-content">
        <iframe
          v-if="viewerUrl"
          class="pdf-viewer"
          :src="viewerUrl"
          :title="dialogTitle"
        ></iframe>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: {
    articleId: String,
    articleTitle: String,
    searchTexts: { type: Array, default: () => [] },
    originalId: String
  },
  data() {
    return {
      viewerUrl: '',
      dialogTitle: ''
    }
  },
  computed: {
    ...mapState({
      openPdfDialog: state => state.leaderStore.openPdfDialog,
      selectedPdf: state => state.leaderStore.selectedPdf
    }),
    cvText() {
      return this.$t('reg.cv')
    }
  },
  watch: {
    selectedPdf(newVal) {
      if (newVal && newVal.url) {
        this.startPDF(newVal)
      } else {
        this.clearDialog()
      }
    }
  },
  methods: {
    startPDF(pdfFile) {
      this.dialogTitle = this.cvText + ' - ' + pdfFile.name
      this.viewerUrl = this.getViewerUrl(pdfFile.url)
    },
    getViewerUrl(url) {
      return url ? url.split('#')[0] + '#zoom=125' : ''
    },
    closeDialog() {
      this.$store.dispatch('leaderStore/openPdfDialog', false)
    },
    clearDialog() {
      this.viewerUrl = ''
      this.dialogTitle = ''
    }
  }
}
</script>
<style lang="scss">
.pdf-tooltip {
  @media only screen and (max-width: 960px) {
    display: none !important;
  }
}
.pdf-link {
  text-decoration: none;
  .v-card.pdf-article {
    height: 100%;
    width: 300px;
    text-align: center;
    margin: 0 5px;
    padding: 20px 10px;

    .pdf-image {
      width: 70px;
    }
    .pdf-title {
      margin-bottom: 0;
      font-weight: bold;
      color: #002956;

      &.pdf-title-category {
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      &.pdf-title-result {
        .text__highlight {
          background: #adeeff;
        }
      }
    }
  }
}

.pdf-dialog-container {
  overflow-x: hidden;
  background: #e6e6e6;

  .pdf-toolbar.v-sheet.v-toolbar {
    position: sticky;
    top: 0;
    z-index: 1;
    width: 100%;
  }
  .pdf-content {
    height: calc(100vh - 64px);
    position: relative;
    width: 100%;

    .pdf-viewer {
      border: 0;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
